import { FC } from 'react';
import Chip from '../chip';
import { getUserEventActionProps } from './helpers';
import { PolicyDecision, FileUpload } from '@/lib/models/user-event';
import { ChipSize } from '../chip/helpers';

interface Props {
  action: PolicyDecision;
  fileUpload?: FileUpload;
  size?: ChipSize;
}

const ActionChip: FC<Props> = ({ action, fileUpload, size = 'small' }) => {
  const { decision } = action;
  const { label, color } = getUserEventActionProps(decision, fileUpload);
  return <Chip label={String(label).toUpperCase()} color={color} size={size} />;
};

export default ActionChip;
